import React, { Component } from 'react';
import PropTypes from 'prop-types';

import env from 'lib/env';
import { ErrorBoundary as VoltaErrorBoundary } from 'components/volta/error-boundary';

const { ENVIRONMENT } = env();

const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

const handleError = (error, info) => {
  console.warn(error, info);
  if (ENVIRONMENT !== 'local') {
    window.location = '/';
  }
};

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  // We'd love to add a message here, but the JS on the page is crashing
  // Because of that, message dispatching is unreliable.
  componentDidCatch(error, info) {
    this.setState({ hasError: true });
    handleError(error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="text-center padding-top-40">
          <h1 className="text-color-dark-slate text-weight-black text-size-72">Aw Shucks</h1>
          <div>Something went wrong. Please refresh the page to try again .</div>
        </div>
      );
    }

    return (
      <VoltaErrorBoundary onError={handleError}>
        {this.props.children}
      </VoltaErrorBoundary>
    );
  }
}

ErrorBoundary.propTypes = propTypes;
export default ErrorBoundary;
